// Shared Airbrake notifier. Kept as a window-scoped singleton so multiple Vite
// bundles on the same page (e.g. the airbrake entrypoint + the editor bundle)
// reuse one instance rather than each patching window error handlers.
// eslint-disable-next-line import/no-extraneous-dependencies
import { Notifier } from "@airbrake/browser";

function buildNotifier() {
  const airbrake = new Notifier({
    projectId: 513828,
    projectKey: "11a30a6671a383d017c6abcada2048d2",
    environment:
      document.querySelector("meta[name=rails-env]")?.content || "unknown"
  });

  airbrake.addFilter(notice => {
    // Always keep notices we report explicitly (e.g. upload failures); their
    // stack runs through library frames so the app-only check below would
    // otherwise drop them.
    if (notice.context?.reportedManually) return notice;

    const { backtrace } = notice.errors[0];
    // Only report errors originating from our own code, not external scripts.
    const isFromApp = (backtrace || []).every(url =>
      url.file.includes("/app/javascript")
    );

    return isFromApp ? notice : null;
  });

  return airbrake;
}

const airbrake =
  (typeof window !== "undefined" && window.papierAirbrake) || buildNotifier();

if (typeof window !== "undefined") {
  window.papierAirbrake = airbrake;
}

export default airbrake;

// Report a handled error to Airbrake with extra context. Never throws.
export function notifyError(error, params = {}) {
  try {
    airbrake.notify({
      error: error instanceof Error ? error : new Error(String(error)),
      params,
      context: { reportedManually: true }
    });
  } catch (_) {
    // error reporting must never break the app
  }
}
